import formName from 'constants/formName'
import { actions } from 'data'
import { notifyError } from 'data/App/sagas'
import { TwoFactorFormType } from 'data/types'
import { call, put } from 'redux-saga/effects'
import { disable2FA } from 'services/api/user'
import { Response } from 'utils/fetchApi'

export default function* disableTotpStep(form: TwoFactorFormType) {
  const data: Response<void> = yield call(disable2FA, {
    code: form.twoFactorCode!,
    type: 'TOTP'
  })

  yield put(actions.form.change(formName.TWO_FACTOR, 'loading', false))

  if (!data.ok) {
    yield call(notifyError, data.error.cause, 'KO_VERIFY_TOTP')
    return
  }

  yield put(actions.auth.setTwoFactorStatus([]))

  yield put(actions.app.hideModal('DISABLE_TWO_FACTOR'))
}
